import { Court, ApiResponse } from '@court-sync/shared';
import { apiGet, apiPost, apiPut, apiDelete } from './apiClient';

const courtService = {
  async getCourts(academyId?: string): Promise<ApiResponse<Court[]>> {
    const params = academyId ? { academyId } : {};
    return apiGet<Court[]>('/courts', { params });
  },

  async getCourt(id: string): Promise<ApiResponse<Court>> {
    return apiGet<Court>(`/courts/${id}`);
  },

  async createCourt(courtData: Omit<Court, 'id' | 'createdAt' | 'updatedAt'>): Promise<ApiResponse<{ id: string }>> {
    return apiPost<{ id: string }>('/courts', courtData);
  },

  async updateCourt(id: string, courtData: Partial<Omit<Court, 'id' | 'createdAt' | 'updatedAt'>>): Promise<ApiResponse> {
    return apiPut(`/courts/${id}`, courtData);
  },

  async deleteCourt(id: string): Promise<ApiResponse> {
    return apiDelete(`/courts/${id}`);
  },
};

export { courtService };
